export default {
  link: {
    color: 'blue',
  },
};
